export const treeBg = "/images/tree-4.png"

export const carbonBundle = {
  title: {
    ko: "탄소 발생량 관리",
    en: "Carbon Emissions Management",
    es: "Gestion de emisiones de carbono"
  },
  description: {
    ko: "실시간 리소스 사용량 기반 탄소 배출량",
    en: "Carbon emissions based on real-time resource consumption",
    es: "Emisiones de carbono basadas en el consumo de recursos en tiempo real"
  },
  total: {
    label: { ko: "총 배출량", en: "Total Emissions", es: "Emisiones totales" },
    unit: { ko: "kgCO₂", en: "kgCO₂", es: "kgCO₂" }
  },
  tree: {
    title: { ko: "소나무 환산 기준", en: "Pine Tree Equivalent", es: "Equivalente en pinos" },
    unit: { ko: "그루", en: "Trees", es: "arboles" },
    description: {
      ko: "연간 탄소 흡수량 기준",
      en: "Based on annual carbon absorption",
      es: "Basado en la absorcion anual de carbono"
    }
  },
  report: {
    ko: "탄소 발생 리포트 상세 조회",
    en: "View Carbon Emissions Report",
    es: "Ver informe de emisiones de carbono"
  },
  resources: {
    elect: {
      title: {
        ko: "전기 탄소 배출",
        en: "Electricity Emissions",
        es: "Emisiones por electricidad"
      }
    },
    water: {
      title: { ko: "수도 탄소 배출", en: "Water Emissions", es: "Emisiones por agua" }
    },
    gas: {
      title: { ko: "가스 탄소 배출", en: "Gas Emissions", es: "Emisiones por gas" }
    }
  },
  ratio: {
    ko: "전체의 {ratio}",
    en: "{ratio} of total",
    es: "{ratio} del total"
  }
}
